import PodcastClipThumbnails from './PodcastClipThumbnails';

export default PodcastClipThumbnails;
